import { render, staticRenderFns } from "./cities.vue?vue&type=template&id=48a6265c&scoped=true&"
import script from "./cities.vue?vue&type=script&lang=js&"
export * from "./cities.vue?vue&type=script&lang=js&"
import style0 from "./cities.vue?vue&type=style&index=0&id=48a6265c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6265c",
  null
  
)

export default component.exports